// extracted by mini-css-extract-plugin
module.exports = {"border":"connection-module__border___2BPOa","odd":"connection-module__odd___1ifRO"};